import { motion } from "framer-motion";

interface StorySectionProps {
  data?: {
    story?: string;
  };
}

export const StorySection = ({ data }: StorySectionProps) => {
  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 },
  };

  return (
    <motion.section {...fadeIn} className="space-y-6 text-left">
      <h2 className="text-3xl font-semibold">Our Story</h2>
      <p className="text-lg text-muted-foreground leading-relaxed">
        {data?.story || "At Supplyfied, we believe in simplifying hotel operations by merging technology, industry expertise, and customer-focused solutions. Our mission is to transform the hospitality sector through seamless automation and data-driven insights—empowering hotels to focus on delivering unforgettable guest experiences."}
      </p>
      <p className="text-lg text-muted-foreground leading-relaxed">
        Since our founding, we've worked tirelessly to reshape how hotels manage procurement, operations, and compliance. Guided by our core values, we continuously innovate to deliver results that matter.
      </p>
    </motion.section>
  );
};